import React from 'react';

const GarantiaRifaTech: React.FC = () => {
	return (
		<section className="padding-x mb-5 text-center">
			<img src={`${process.env.PUBLIC_URL}/images/garantia-500x500.png`}
				alt="Garantia Rifa Tech"
				style={{height: "200px", width: "200px"}} />

			<div>
				<span className="d-block title-sm-common mb-1 title-primary">
					Garantia Rifa Tech
            </span>

				<span className="d-block" style={{ lineHeight: "1.5", fontSize: "1.2rem" }}>
					A Rifa Tech trabalha em cada rifa para garantir a segurança
					e credibilidade de todo o processo. Por isso acompanhamos o
					resultado das rifas, e a devida entrega dos prêmios aos vencedores.
					Caso seja identificada fraude por parte do vendedor, os compradores
					receberão de volta todo o dinheiro que pagaram. Isso traz mais
					credibilidade para a Rifa Tech e, consequentemente, para sua rifa.
            </span>
			</div>
		</section>
   );
}

export default GarantiaRifaTech;